export enum TipoGatilhoComanda {
    "BOTAO_CONCLUIR" = "BOTAO_CONCLUIR",
    "BOTAO_IMPRIMIR" = "BOTAO_IMPRIMIR"
}